var canvas = {};
export {
  canvas as __exports
};
//# sourceMappingURL=index214.js.map
